const audienceColor = '#fff341';
const touchpointColor = '#6ed8ff';
const goalColor = '#5dff3e';

export default [{
    name: 'Audience',
    displayName: 'Au',
    color: audienceColor
}, {
    name: 'Facebook',
    displayName: 'fb',
    color: touchpointColor
}, {
    name: 'Email',
    displayName: '@',
    color: touchpointColor
}, {
    name: 'Website',
    displayName: 'www',
    color: touchpointColor
}, {
    name: 'OnlineAd',
    displayName: 'AD',
    color: touchpointColor
}, {
    name: 'Telemarketing',
    displayName: 'TM',
    color: touchpointColor
}, {
    name: 'Goal',
    displayName: 'GOAL',
    color: goalColor
}];